import { render, staticRenderFns } from "./AuthFormWrapper.vue?vue&type=template&id=159dac02&scoped=true"
import script from "./AuthFormWrapper.vue?vue&type=script&lang=js"
export * from "./AuthFormWrapper.vue?vue&type=script&lang=js"
import style0 from "./AuthFormWrapper.vue?vue&type=style&index=0&id=159dac02&prod&lang=scss&scoped=true"
import style1 from "./AuthFormWrapper.vue?vue&type=style&index=1&id=159dac02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159dac02",
  null
  
)

export default component.exports